import React, { useState } from "react";
import fetch from "lib/fetch";
import { isSessionActive } from "lib/currentUser/session";

const CURRENT_USER_INFO_PATH = "/users/current.json";
export const EDITOR_USER_TYPE = "Editor";

class Cache {
  static get currentUser() {
    delete this.currentUser;

    this.currentUser = fetch(CURRENT_USER_INFO_PATH)
      .then(data => data.json());

    return this.currentUser;
  }
}

/**
 * Promise to fetch the current user.
 *
 * @returns {Promise}
 */
export function currentUser() {
  if (!isSessionActive()) { return Promise.resolve({}); }

  return Cache.currentUser;
}

/**
 * React hook to fetch current user.
 *
 * @returns {{loading: Boolean, error: Boolean, user: Object}}
 */
export function useCurrentUser() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [user, setUser] = useState({});

  React.useEffect(() => {
    currentUser()
      .then(data => setUser(data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return { loading, error, user };
}
